import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';

export interface KitLabBackendSegment {
  segmentKey: string;
  color: string;
}

export interface KitLabBackendKit {
  _id: string;
  name: string;
  gender: string;
  isDefault?: boolean;
  layoutPreset?: string;
  segments?: KitLabBackendSegment[];
  sportIds?: string[];
  createdAt?: string;
  updatedAt?: string;
}

function getBaseConfig(user: AppUser) {
  const { roleSessionKey: key } = user;

  return {
    headers: { usid: key }
  };
}

export function getKitLabKits(user: AppUser, params?: { gender?: string; sportId?: string }) {
  const { activeSchoolId } = user;
  const config = {
    ...getBaseConfig(user),
    params
  };

  return axios
    .get(`${window.apiBase}/i/schools/${activeSchoolId}/kit-lab/kits`, config)
    .then(response => response.data.kits as KitLabBackendKit[]);
}

export function createKitLabKit(user: AppUser, data: Partial<KitLabBackendKit>) {
  const { activeSchoolId } = user;
  const config = getBaseConfig(user);

  return axios
    .post(`${window.apiBase}/i/schools/${activeSchoolId}/kit-lab/kits`, data, config)
    .then(response => response.data.kit as KitLabBackendKit);
}

export function updateKitLabKit(user: AppUser, kitId: string, data: Partial<KitLabBackendKit>) {
  const { activeSchoolId } = user;
  const config = getBaseConfig(user);

  return axios
    .put(`${window.apiBase}/i/schools/${activeSchoolId}/kit-lab/kits/${kitId}`, data, config)
    .then(response => response.data.kit as KitLabBackendKit);
}

export function setKitLabDefaultKit(user: AppUser, kitId: string) {
  const { activeSchoolId } = user;
  const config = getBaseConfig(user);

  return axios
    .post(`${window.apiBase}/i/schools/${activeSchoolId}/kit-lab/kits/${kitId}/set-default`, {}, config)
    .then(response => response.data.kit as KitLabBackendKit);
}

export function deleteKitLabKit(user: AppUser, kitId: string) {
  const { activeSchoolId } = user;
  const config = getBaseConfig(user);

  return axios
    .delete(`${window.apiBase}/i/schools/${activeSchoolId}/kit-lab/kits/${kitId}`, config)
    .then(response => response.data.kits as KitLabBackendKit[]);
}
